import { PurchaseRequisitionStatusEnum } from './PurchaseRequistionStatusEnum';
import { IAuthor } from '@lib/user';

export interface IPurchaseRequisitionHistoryEntry {
    comment: string;
    timestamp: string;
    author: IAuthor;
    superUser: IAuthor;
    status: PurchaseRequisitionStatusEnum;
    action: PurchaseRequisitionAction;
}

export enum PurchaseRequisitionAction {
    CREATED = 'CREATED',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    WITHDRAWN = 'WITHDRAWN',
    TO_BE_REWORKED = 'TO_BE_REWORKED',
    APPROVER_CHOSEN = 'APPROVER_CHOSEN',
    RESULT_DOCUMENT_SELECTED = 'RESULT_DOCUMENT_SELECTED',
    REWORKED = 'REWORKED',
}
